import { useState } from 'react'
import { useRecordContext } from 'react-admin'
import Switch from '@mui/material/Switch'
import FormControlLabel from '@mui/material/FormControlLabel'
import get from 'lodash/get'

import useUpdateDataProvider from '../hooks/useUpdateDataProvider'

import { EPISODE_STATUS, PODCAST_STATUS_DISPLAY } from './constants'

const EpisodeStatusField = props => {
  const { disabled } = props
  const record = useRecordContext()
  const updateDataProvider = useUpdateDataProvider()
  const [status, setStatus] = useState(record.status)

  const handleChange = async () => {
    const data = {
      status:
        status === EPISODE_STATUS.PUBLISHED
          ? EPISODE_STATUS.UNPUBLISHED
          : EPISODE_STATUS.PUBLISHED,
    }

    const response = await updateDataProvider(
      'episodes',
      { id: record.id, data },
      {
        onSuccess: {
          notification: { body: 'Episode updated', level: 'info' },
          redirectTo: '/episodes',
        },
        onFailure: {
          notification: {
            body: 'Error: Episode not updated',
            level: 'warning',
          },
        },
      },
    )
    if (get(response, 'data.status', null)) {
      setStatus(response.data.status)
    }
  }

  return [
    EPISODE_STATUS.PUBLISHED,
    EPISODE_STATUS.UNPUBLISHED,
    EPISODE_STATUS.UNDER_REVIEW,
  ].includes(record.status) ? (
    <FormControlLabel
      control={
        <Switch
          checked={status === EPISODE_STATUS.PUBLISHED}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={PODCAST_STATUS_DISPLAY[status]}
    />
  ) : (
    PODCAST_STATUS_DISPLAY[status]
  )
}

export default EpisodeStatusField
